import { addTransitionToTimeline } from '~/actions/projectData/addTransitionToTimeline'
import TimelineLayer from '../Layer'
import { AssetHistoryAction } from './AssetHistoryAction'
import { HistoryActionType } from './HistoryActionType'
import { undoCreateTransition } from '~/actions/undoRedo/transitionUndoRedoActions'


export class TransitionCreationAction extends AssetHistoryAction {

  constructor(payload, ...params) {
    super(HistoryActionType.TransitionCreationAction, payload, ...params)
    const { isNewLayer, newLayer, newLayerIndex, deltaOnDrop, savedParams } = payload
    this.isNewLayer = isNewLayer
    this._deltaOnDrop = deltaOnDrop
    this._savedParams = savedParams
    if (isNewLayer) {
      this.newLayer = newLayer instanceof TimelineLayer ? newLayer : new TimelineLayer(newLayer)
      this.newLayerIndex = newLayerIndex
    }
  }

  get isNewLayer() {
    return this._isNewLayer
  }

  set isNewLayer(v) {
    this._isNewLayer = v
  }

  get newLayer() {
    return this._newLayer
  }

  set newLayer(v) {
    this._newLayer = v
  }

  get newLayerIndex() {
    return this._newLayerIndex
  }

  set newLayerIndex(v) {
    this._newLayerIndex = v
  }

  get deltaOnDrop() {
    return this._deltaOnDrop
  }

  set deltaOnDrop(v) {
    this._deltaOnDrop = v
  }

  get savedParams() {
    return this._savedParams
  }

  * undo() {
    const { asset, savedParams } = this
    yield undoCreateTransition(...asset, savedParams)
  }

  * redo() {
    yield addTransitionToTimeline(...this.asset, this.asset.layerId)
  }

}
